/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum AssignReasonToDowntimeBehaviourType {
  ShiftReport = 'ShiftReport',
  ApprovalReport = 'ApprovalReport',
  Task = 'Task'
}
